import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import FloorDetail from '../../components/floor/FloorDetail';

import { translate } from 'react-i18next';
import { defaultRejectHandler } from '../../utils/utility';
import { editFloor } from '../../redux/floor/floor_actions';

class FloorEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.floorDetail = undefined;
  }

  onSaveHandler() {
    const editedFloor = this.floorDetail.getWrappedInstance().getWrappedInstance().getFloorData();
    this.props.editFloor({ ...editedFloor, id: this.props.floor.id });
  }

  render() {
    const { isEditing, errorMessage, editFloor, floor, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit floor')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloorDetail
            floor={floor}
            ref={ref => (this.floorDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="floor-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.floor.errorMessage,
  isEditing: state.floor.isEditing,
});

const mapDispatchToProps = (dispatch, props) => ({
  editFloor: floor =>
    defaultRejectHandler(
      dispatch(editFloor(floor.id, floor.name, props.floor.building_id, floor.description)),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(FloorEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/floor/FloorEditModal.js